import type { AccountQueryData } from './queries/useAccount';

type Account = AccountQueryData['account'];

export const getName = (account: Account | undefined) =>
  [account?.firstName, account?.middleName, account?.lastName]
    .filter(Boolean)
    .join(' ');

export const getInitials = (account: Account | undefined) =>
  `${account?.firstName?.charAt(0)}${account?.lastName?.charAt(0)}`;

export const isMissingRequiredFields = (
  account: Account | undefined,
  isEmbedded?: boolean,
) => {
  if (isEmbedded) return false;

  if (!account?.gender || !account?.city) return true;

  return false;
};
